<template>
  <p>In 2014, three VizbiPlus Showcase events took place:</p>
  <ShowcaseEventList year="2014" />
</template>

<script setup>
import ShowcaseEventList from "@/components/ShowcaseEventList.vue";
</script>
